import { render, staticRenderFns } from "./ui-theme.vue?vue&type=template&id=3608ee13&"
import script from "./ui-theme.vue?vue&type=script&lang=js&"
export * from "./ui-theme.vue?vue&type=script&lang=js&"
import style0 from "./ui-theme.vue?vue&type=style&index=0&id=3608ee13&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VCard,VMain,VSpacer})
